var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNodejs = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  preserveAspectRatio: "xMinYMin meet",
  viewBox: "0 0 256 282",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#8cc84b"
}, /*#__PURE__*/React.createElement("path", {
  d: "M117 4c6-4 16-4 22 0l105 59q11 7 11 18v119q0 13-11 19l-105 60q-11 6-23-1l-32-18-6-5 6-2 12-6h4l26 15q3 2 6-1l103-58q2-1 1-3V82q1-2-2-4L130 20h-4L22 78q-3 2-2 4v118l1 3 28 16q8 5 18 2 8-4 8-12V92q1-3 3-3h14q3 1 3 3v118q0 18-14 27-19 9-39-1l-30-17q-11-6-11-19V81q0-12 11-18z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147 86q23-3 45 7 17 11 17 29-1 3-4 3h-13q-3 0-3-4-1-9-10-13-12-6-26-4-11 0-19 4-6 6-4 14 3 4 8 5c19 5 38 5 56 11q13 5 17 15 6 18-5 32-10 10-24 12-17 4-35 2-17-1-32-12-11-10-10-26 0-3 3-2h13q3-1 4 3 0 8 7 14c9 6 20 5 31 5q13 2 25-6 6-5 4-13-2-6-9-7c-18-6-38-4-56-10q-12-4-17-15-6-18 6-32 13-11 31-12"
}))));
export default SvgNodejs;